import { Badge } from "@mantine/core";
import { MMI_COLORS } from "../RoomColoring";

interface MmiBadgeProps {
  value: number;
}

export const MmiBadge: React.FC<MmiBadgeProps> = ({ value }) => {
  const color = MMI_COLORS[value] ?? "gray"; // Default to gray if not found
  const label = `MMI:${value}`;

  return (
    <Badge
      variant="filled"
      color={color}
      size="md"
      style={{
        color: "#000000", // Ensure text is readable; adjust based on color contrast if needed
      }}
    >
      {label}
    </Badge>
  );
};
